import { render, staticRenderFns } from "./AreaDetails.vue?vue&type=template&id=b804ea6e&scoped=true"
import script from "./AreaDetails.vue?vue&type=script&lang=ts"
export * from "./AreaDetails.vue?vue&type=script&lang=ts"
import style0 from "./AreaDetails.vue?vue&type=style&index=0&id=b804ea6e&prod&lang=css&scoped=true"
import style1 from "./AreaDetails.vue?vue&type=style&index=1&id=b804ea6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b804ea6e",
  null
  
)

export default component.exports